import { createApp } from 'vue'
import {
  Button,
  Form,
  Input,
  Layout,
  Menu,
  Card,
  Table,
  Tabs,
  Checkbox,
  Dropdown,
  Select,
  DatePicker,
  Divider,
  Row,
  Col,
  Statistic,
  Avatar,
  Tooltip,
  Badge,
  Breadcrumb,
  Modal,
  message,
  ConfigProvider
} from 'ant-design-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'ant-design-vue/dist/reset.css';
import 'driver.js/dist/driver.css';
import '@/assets/styles/user-dropdown.css';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import { sanitizeHtml } from '@/utils/sanitize';

// 按需引入组件

const app = createApp(App)

app.use(ConfigProvider, {
  locale: zhCN,
});

// 注册组件
app.use(Button)
app.use(Form)
app.use(Input)
app.use(Layout)
app.use(Menu)
app.use(Card)
app.use(Table)
app.use(Tabs)
app.use(Checkbox)
app.use(Dropdown)
app.use(Select)
app.use(DatePicker)
app.use(Divider)
app.use(Row)
app.use(Col)
app.use(Statistic)
app.use(Avatar)
app.use(Tooltip)
app.use(Badge)
app.use(Breadcrumb)
app.use(Modal)

app.config.globalProperties.$message = message
app.config.globalProperties.sanitizeHtml = sanitizeHtml

app.use(store)
app.use(router)
app.mount('#app')
